module.exports = __webpack_public_path__ + "static/media/base.70ade554.svg";